module.exports = __webpack_public_path__ + "685eb22fdaa9a5fca00fd3d5f701ab2d.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/15-Betsolutions-Underground-Tuning.png
// module id = 1737
// module chunks = 2